import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchEducationList,
  fetchEducationCategoryList,
  fetchEducationCatList,
  fetchEducationArchiveCatList,
} from "../../actions/education";
import HolderContainer from "../../components/Reusable/HolderContainer";
import EducationListItem from "./EducationListItem";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import InfoBox from "../../components/Reusable/InfoBox";
import { useTranslation } from "react-i18next";

const EducationList = () => {
  const dispatch = useDispatch();

  const { educationList, educationCategoryList } = useSelector(
    (state) => state.educationReducer
  );
  const { t } = useTranslation();

  const [activeCategory, setActiveCategory] = useState(0);
  const [activeMainCategory, setActiveMainCategory] = useState(0);

  useEffect(() => {
    dispatch(fetchEducationList());
    dispatch(fetchEducationCategoryList());
  }, [dispatch]);

  const changeCategoryEducation = (id) => {
    setActiveCategory(id);
    dispatch(fetchEducationCatList(id));
  };

  const changeCategoryActiveEducation = (id) => {
    setActiveMainCategory(id);
    setActiveCategory(0);
    dispatch(fetchEducationCatList(id));
  };

  const changeCategoryArchiveEducation = (id) => {
    setActiveMainCategory(id);
    setActiveCategory(0);
    dispatch(fetchEducationArchiveCatList(id));
  };

  return (
    <HolderContainer>
      <div className="education-list-container">
        <Breadcrumb title={t("educationList.breadcrumb")} />

        <div className="education-list-category">
          <div className="education-list-category-items">
            <div className="education-list-category-main-items">
              <div
                className={`education-list-category-item ${
                  activeMainCategory === 0 ? "active" : ""
                }`}
                onClick={() => changeCategoryActiveEducation(0)}
              >
                {t("educationList.categories.all")}
              </div>
              <div
                className={`education-list-category-item ${
                  activeMainCategory === 9999999999 ? "active" : ""
                }`}
                onClick={() => changeCategoryArchiveEducation(9999999999)}
              >
                {t("educationList.categories.archive")}
              </div>
            </div>
            {activeMainCategory !== 9999999999 && (
              <div className="education-list-category-other-items">
                {educationCategoryList.length > 0 &&
                  educationCategoryList?.map((category, key) => (
                    <div
                      className={`education-list-category-item ${
                        activeCategory === category.id ? "active" : ""
                      }`}
                      key={key}
                      onClick={() => changeCategoryEducation(category.id)}
                    >
                      {category.name}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>

        <div className="education-list-main-items">
          {/* {educationCategoryList?.length > 0 ? ( */}
          <Fragment>
            {educationList.length > 0 ? (
              educationList?.map((education) => (
                <EducationListItem item={education} />
              ))
            ) : (
              <InfoBox text={t("educationList.infoBox.noEducation")} />
            )}
          </Fragment>
          {/* ) : (
            <InfoBox text={t("educationList.infoBox.noEducation")} />
          )} */}
        </div>
      </div>
    </HolderContainer>
  );
};

export default EducationList;
